//----------------------------------- IMPORT THE CONFIGURED APIS -----------------------------------
import axiosInstance from './axiosInstance';
import {
    USER_LOGIN_API_URL,
    FSM_LIST_API_URL,
    ASM_LIST_API_URL,
    DISTRIBUTOR_LIST_API_URL,
    USER_LIST_BY_ROLE_API,
    DEALER_LIST_API_URL_MANAGEMENT,
    DEALER_LIST_API_URL,
    COMPLAIN_DETAILS_API_URL,
    ORDER_SEARCH_API_URL,
    ORDER_DETAILS_SEARCH_API_URL,
    COMPLAIN_UPDATE_API_URL,
    STOCK_ALLOCATION_LIST_API_URL,
    VEHICLE_LIST_API_URL,
    DRIVER_HELPER_API_URL,
    SALES_TYPE_API_URL,
    SALES_REP_LIST_API_URL,
    DEALER_TYPE_LIST_API_URL,
    ITEMS_LIST_API_URL,
    ITEMS_PRICES_AND_STOCK_API_URL,
    SAVE_STOCK_ALLOCATION_API_URL,
    FETCH_ADJUSTMENT_REASONS_API_URL,
    SAVE_STOCK_ADJUSTMENT_API_URL,
    SAVE_INITIAL_STOCK_API_URL,
    ROUTE_LIST_API_URL,
    DISPATCH_LIST_REP_API_URL,
    SAVE_DISPATCH_API_URL,
    MENU_LOAD_API_URL,
    DEALER_VISIT_API_URL,
    DISPATCH_LIST_API_URL,
    DISPATCH_ITEM_API_URL,
    GATE_PASS_API_URL,
    GATE_PASS_IN_API_URL,
    GATE_PASS_IN_ITEM_API_URL,
    GATE_PASS_API_URL_SAVE,
    STOCK_ALLOCATION_BY_ID_API_URL,
    UPDATE_STOCK_ALLOCATION_API_URL,
    STOCK_ALLOCATION_POPUP_API_URL,
    FETCH_DISTRIBUTOR_STOCK_LIST_API_URL,
    DAILY_SALE_REPORT_API_URL,
    DISPATCH_UPDATE_ITEM_API_URL,
    UPDATE_DISPATCH_API_URL,
    GRID_DISPATCH_API_URL,
    DISPATCH_REP_API_URL,
    COUNT_DATA_API_URL,
    PAYMENT_TABLE_DATA_API_URL,
    INVOICE_BY_DISTRIBUTOR_API_URL,
    DEALER_POPUP_API_URL,
    INVOICE_DETAILS_API_URL,
    VEHICLE_LIST_BY_PROFILE_API_URL,
    DISPATCH_ITEMS_SEARCH_API_URL,
    COMPLAINTS_TABLE_DATA_API_URL,
    RECENT_ORDERS_DATA_API_URL,
    DSR_WISE_SALES_DATA_API_URL,
    VEHICLE_LIST_BY_GATEPASSIN_API_URL,
    DISPATCH_ITEMS_SEARCH_BY_GATEPASSIN_API_URL,
    VIEW_DISPATCH_API_URL,
    DISPATCH_EDIT_STOCK_API_URL,
    INVOICE_SUMMARY_API_URL,
    TARGET_VS_ACHIEVEMENT_DATA_API_URL,
    DISTRIBUTOR_LIST_INVOICE_API_URL,
    SALES_REP_LIST_INVOICE_API_URL,
    DISTRIBUTOR_LIST_ORDER_REQUEST_API_URL,
    VEHICLE_LIST_ORDER_REQUEST_API_URL,
    PLANT_LIST_ORDER_REQUEST_API_URL,
    BRIDGING_API_URL,
    ITEMS_LIST_ORDER_API_URL,
    SAVE_PURCHASE_ORDER_API_URL,
    PURCHASE_ORDER_LIST_API_URL,
    PURCHASE_ORDER_DETAILS_API_URL,
    PURCHASE_ORDER_UPDATE_API_URL,
    PURCHASE_ORDER_POPUP_API_URL,
    BRIDGING_TYPE_API_URL,
    PO_SHEDULE_LIST_API_URL,
    PO_LIST_API_URL,
    GRN_SEARCH_API_URL,
    GRN_SAVE_API_URL,
    GRN_LIST_API_URL,
    GRN_POPUP_API_URL,
    GRN_DETAILS_API_URL,
    GRN_ALL_PO_LIST,
    GRN_UPDATE_API_URL,
    PO_SH_APPROVE_API_URL,
    PO_SH_REJECT_API_URL,
    DISTRIBUTOR_LIST_ORDER_REQUEST_API_URL_ALL,
    PO_SCH_REPORT_API_URL,
    REPORT_LOSS_SALE_API_URL,
    REPORT_DISTRIBUTOR_STOCK_API_URL,
    CHANGE_PASSWORD_API_URL,
    REQUEST_OTP_API_URL,
    VERIFY_OTP_API_URL,
    RESET_PASSWORD_API_URL,
    FETCH_DISTRIBUTORS_LIST_API,
    SALE_ROUTE_API_URL,
    VEHICLE_STOCK_API_URL,
    FETCH_DISTRIBUTORS_LIST,
    FETCH_SALES_REPS_LIST,
    INVOICES_AND_PAYMENTS_ON_THE_MAP,
    DISTRICT_LIST_API,
    CANCEL_INVOICE,
    ITEM_LIST_API,
    ITEM_PRICE_SAVE_API,
    SEARCH_ITEM_PRICES_API,
    VIEW_ITEM_PRICES_API,
    ITEM_PRICE_CONFIRM_API,
    USER_ROLE_SAVE_API_URL,
    USER_ROLE_LIST_API_URL,
    USER_ROLE_API_BY_ID_API_URL,
    USER_ROLE_UPDATE_API_URL,
    USER_ROLE_BY_NAME_API_URL,
    ROUTE_LIST_AS_MODULES_API_URL,
    MODULE_ROUTE_SAVE_API_URL,
    USER_ROLE_DETAILS_SAVE_API_URL,
    USER_ROLE_DETAILS_GET_API_URL,
    USER_ROLE_DEATILS_UPDATE_API_URL,
    USER_ROLE_DETAILS_VIEW_BY_ID_API_URL,
    USER_ROLE_LIST_FOR_USERS_API_URL,
    ORG_STRUCTURE_LIST_FOR_USERS_API_URL,
    REPORTING_LIST_BY_ORG_ID_API_URL,
    USER_CREATE_API_URL,
    Company_LIST_API_URL,
    DISTRICT_LIST_API_URL,
    USER_LIST_API_URL,
    USERS_DETAILS_GET_API_URL,
    USER_UPDATE_API_URL,
    USER_DETAILS_BY_ID_VIEW_API_URL,
    MODULE_WISE_USER_NAMES_API_URL,
    FETCH_DASHBOARD_COUNTS,
    FETCH_INVOICE_AND_PAYMENTS,
    FETCH_ORDER_REQUESTS,
    FETCH_DISTRIBUTOR_STOCKS,
    FETCH_TARGET_VS_ACHIEVEMENTS,
    FETCH_VEHICLES_BY_DISTRIBUTOR_API,
    FETCH_DEALER_VISITS,
    FETCH_COMPLAINTS,
    FETCH_PRODUCTIVE_STATS,
    FETCH_LORRY_WISE_SALES,
    FETCH_LORRY_WISE_SALES_DETAILS,
    FETCH_SKU_WISE_SALES_STATS,
    FETCH_SKU_WISE_SALES_DETAILS,
    FETCH_ORG_STRUCTURES_LIST,
    FETCH_NEXT_ORG_STRUCTURES_LIST,
    FETCH_USERS_IN_ORG_STRUCTURE,
    DISPATCH_CANCEL_API_URL,
    ITEM_TYPE_API_URL,
    ITEM_SAVE_API_URL,
    UOM_API_URL,
    ITEM_EDIT_API_URL,
    ITEM_DETAILS_VIEW_API_URL,
    ITEM_UPDATE_API_URL,
    DOWNLOAD_TARGET_API,
    DOWNLOAD_TARGET_MATRIX_API,
    DOWNLOAD_LORRY_TARGET_API,
    SAVE_LORRY_TARGET_API,
    TARGETS_SUMMARY_API,
    TARGETS_LIST_API,
    SAVE_TARGET_VS_ACHIEVEMENTS_API,
    VIEW_TARGET_API,
    LORRY_TARGETS_API,
    ITEM_CODE_API_URL,
    ITEM_VARIANT_SAVE_API_URL,
    FETCH_ITEM_VARIANT_API_URL,
    ITEM_VARIANT_UPDATE_API_URL,
    ITEM_VARIANT_LIST_API_URL,
    FETCH_ALL_ITEM_API,
    STAFF_TYPE_API_URL,
    STAFF_SAVE_API_URL,
    FETCH_ALL_STAFF_API,
    STAFF_EDIT_API_URL,
    STAFF_UPDATE_API_URL,
    STAFF_DETAILS_VIEW_API_URL,
    UPDATE_DEALER_DETAILS_API_URL,
    VERIFY_DEALER_DETAILS_API_URL,
    FETCH_DEALER_GROUPS_API_URL,
    FETCH_DEALERS_BY_GROUPS_API_URL,
    VIEW_DEALER_DETAILS_API_URL,
    DEALER_CATEGORY_LIST_API_URL,
    FETCH_DEALERS_BY_DISTRIBUTORS_API_URL,
    WEB_USER_LOGIN_API_URL,
    WEB_USER_LOGOUT_API_URL,
    SALE_ROUTE_LIST_API_URL,
    FETCH_DEALER_ROUTE_LIST_API_URL,
    UPDATE_DEALER_ROUTE_API_URL,
    BRANCH_LIST_API_URL,
    GET_BANKS_API_URL,
    BANK_SAVE_API_URL,
    BANK_EDIT_API_URL,
    BANK_UPDATE_API_URL,
    INVOICE_PAYMENT_DETAILS,
    DEALER_FINANCIALS_URL,
    DEALER_LIST_BY_ROUTE_API_URL,
    GET_BANK_LIST_API_URL,
    GET_BRANCH_LIST_API_URL,
    ROUTER_LIST_BY_LOGGING_USER_API_URL,
    DEALER_LIST_BY_LOGGING_USER_API_URL,
    SAVE_INVOICE_PAYMENT,
    GET_INVOICE_PAYMENT_DETAILS_API_URL,
    UPDATE_INVOICE_PAYMENT_DETAILS_API_URL,
    GET_BRANCHES_BY_BANKS_API_URL,
    GET_DEALERS_BY_ROUTE_API_URL,
    GET_BANKS_BY_LOGIN_USER_API_URL,
    CANCEL_INVOICE_PAYMENT_API_URL,
    BULK_CANCEL_INVOICE_PAYMENT_API_URL,
    GET_ADVANCE_PAYMENTS_API_URL,
    GET_ADVANCE_PAYMENTS_FILTER_API_URL,
    GET_ADVANCE_PAYMENT_DETAILS_BY_ID_API_URL,
    SAVE_NEW_ADVANCE_PAYMENT_API_URI,
    UPDATE_ADVANCE_PAYMENTS_API_URL,
    CANCEL_ADVANCE_PAYMENTS_API_URL,
    SAVE_INVOICE_PAYMENTS_API_URL,
    SAVE_CUSTOMER_INVOICE_API_URL,
    PROMOTIONS_LIST_API_URL,
    VIEW_PROMOTION_DETAILS_API_URL,
    UPDATE_PROMOTION_API_URL,
    DEALERS_LIST_API_URL,
    SAVE_PROMOTION_API_URL,
    PROMOTION_PRIORITY_API_URL,
    GET_ITEMS_LIST_API_URL,
    REVIEW_PROMOTION_API_URL,
    PROMOTION_ACTIVE_API_URL,
    DAY_END_REPORT_API_URL,
    VEHICLE_REP_LIST_API_URL,
    DIS_WISE_DEA_REPORT_API_URL,
    DIS_WISE_SAL_REPORT_API_URL,
    FETCH_DEALERS_AND_COMPETITORS_API_URL,
    FETCH_DEALERS_AND_COMPETITORS_FILTERING_API_URL,
    GET_BUSINESS_TYPE_LIST_API_URL,
    GET_NATURE_OF_BUSINESS_LIST_API_URL,
    CREATE_NEW_DEALER_API_URL,
    EDIT_DEALER_DETAILS_API_URL,
    USER_UNBLOCK_API_URL,
    GET_USER_GPS_DATA_API_URL,
    SAVE_GPS_TRACKING_SCHEDULE_API_URL,
    DEA_STATE_SAL_REPORT_API_URL,
    ASM_FSM_WISE_SAL_REPORT_API_URL,
    DIS_WISE_DEA_STOCK_REPORT_API_URL,
    DAILY_SAL_MONITOR_REPORT_API_URL,
    DEALER_VAT_REPORT_API_URL,
    GET_REPORTING_USERS_API_URL,
    FETCH_DATA_COUNTS_UNDER_USER,
    GET_ROUTES_LIST_API_URL,
    VIEW_ROUTE_DETAILS_API_URL,
    ADVANCE_VIEW_ROUTE_DETAILS_API_URL,
    GET_DEALERS_ROUTES_LIST_API_URL,
    CREATE_NEW_ROUTE_API_URL,
    EDIT_ROUTE_DETAILS_API_URL,
    STOCK_RETURN_REPORT_API_URL,
    CASH_BALANCING_REPORT_API_URL,
    FETCH_CASH_BALANCING_USERS_API_URL,
    GET_AGEING_ANALYSIS_REPORT_API,
    CREATE_NEW_ITEM_API_URL,
    GET_ITEM_DETAILS_API_URL,
    EDIT_ITEM_API_URL,
    GET_MOBILE_APP_USER_TYPES_API_URL,
    GET_USERS_BY_TYPE_API_URL,
    GET_LOCATIONS_HISTORY_API_URL,
    FETCH_OPEN_STOCK_BY_ITEM_API_URL,
    GET_ROUTES_WITH_DEALERS_API_URL,
    SAVE_DAILY_SCHEDULE_API_URL,
    FETCH_DELIVERY_SCHEDULE_LIST_API_URL,
    FETCH_HOLIDAYS_API_URL,
    CREATE_NEW_HOLIDAY,
    UPDATE_HOLIDAY_API_URL,
    FETCH_WORKING_DAYS_API_URL,
    SAVE_WORKING_DAYS_API_URL,
    ITEMS_PRICES_AND_STOCK_BY_DEALER_API_URL,
    GET_DEALER_GROUPS_LIST_API_URL,
    VIEW_DEALER_GROUP_DETAILS_API_URL,
    GET_DEALERS_LIST_API_URL,
    CREATE_DEALER_GROUP_API_URL,
    ADVANCED_DEALER_GROUP_VIEW_API_URL,
    EDIT_DEALER_GROUP_API_URL,
    GET_ALL_PROMOTIONS_LIST_API_URL,
    FETCH_STOCK_ADJUSTMENT_APPROVAL_LIST_API_URL,
    UPDATE_STOCK_ADJUSTMENT_ITEM_APPROVAL_API_URL,
    FETCH_STOCK_ADJUSTMENT_HISTORY_LIST_API_URL,
    GET_MODULES_LIST_API_URL,
    GET_MODULES_SUMMARY_API_URL,
    VIEW_MODULE_DETAILS_API_URL,
    GET_PAGE_TYPES_API_URL,
    CREATE_MODULE_API_URL,
    UPDATE_MODULE_API_URL,
    GET_SUBMODULES_LIST_API_URL,
    GET_DELIVERY_SCHEDULE_TIME_SLOTS_API_URL,
    GET_DEALERS_BY_ROUTES_API_URL,
    CREATE_DELIVERY_SCHEDULE_API_URL,
    DEALER_CATEGORIES_API_URL,
    GET_DEALER_LIST_BY_DISTRIBUTOR_INDIVIDUAL_DEALER_CATEGORY_API_URL,
    GET_ALL_DELIVERY_SCHEDULES_API_URL,
    GET_DELIVERY_SCHEDULE_BY_ID_API_URL,
    UPDATE_DELIVERY_SCHEDULE_API_URL,
    VIEW_DELIVERY_SCHEDULE_API_URL,
    CREDIT_NOTE_REPORT_API_URL,
    GET_NATURE_OF_BUSINESS_BY_DISTRIBUTOR_DEALER_CATEGORY_API_URL,
    GET_DEALERS_BY_DISTRIBUTOR_CATEGORY_NATURE_API_URL,
    GET_DEALERS_BY_ROUTES_HISTORY_API_URL,
    FETCH_SALES_EXECUTIVES_LIST,
    FETCH_PRODUCTIVE_NON_PRODUCTIVE_LOGS_DETAILS,
    GET_DISTRIBUTOR_VEHICLES_API_URL,
    FETCH_CALL_SUMMARY_STATS
} from './apiConfig';
import profile from "@/components/header/profile.vue";

//----------------------------------- USER WISE AUTHENTICATION API SERVICES -----------------------------------
//USER LOGIN AND AUTHENTICATION API SERVICE
export const webUserLogin = (username, password) => {
    return axiosInstance.post(WEB_USER_LOGIN_API_URL, {
        username,
        password,
        platform: '1'
    })
}

//USER LOGOUT API SERVICE
export const webUserLogout = (token) => {
    return axiosInstance.post(WEB_USER_LOGOUT_API_URL, {
        token,
    }, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}

//----------------------------------- USER AUTHENTICATION API SERVICES -----------------------------------
//USER LOGIN API SERVICE (USER NAME IS MOBILE, PASSWORD)
export const userLogin = (token, username, password) => {
    return axiosInstance.post(USER_LOGIN_API_URL, {
        token,
        username,
        password,
        platform: '1',
    }, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

//CHANGE PASSWORD API SERVICE (SET PASSWORD/CHANGE PASSWORD - SETTINGS & PASSWORD RESET WHEN IT EXPIRED)
export const changePassword = (token, id, old_password, password, password_confirmation) => {
    return axiosInstance.post(CHANGE_PASSWORD_API_URL, {
        token,
        id,
        old_password,
        password,
        password_confirmation
    }, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

//REQUEST OTP API SERVICE (SEND SIX DIGITS ONE TIME PASSWORD (OTP) TO GIVEN MOBILE NUMBER)
export const requestOTP = (mobile) => {
    return axiosInstance.post(REQUEST_OTP_API_URL, {
        mobile,
    });
};

//VERIFY OTP API SERVICE
export const verifyOTP = (token, mobile, otp) => {
    return axiosInstance.post(VERIFY_OTP_API_URL, {
        token,
        mobile,
        otp
    }, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

//RESET PASSWORD API SERVICE
export const resetPassword = (token, mobile, otp, password, password_confirmation) => {
    return axiosInstance.post(RESET_PASSWORD_API_URL, {
        token,
        mobile,
        otp,
        password,
        password_confirmation
    }, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

//----------------------------------- DASHBOARD API SERVICE -----------------------------------
//FOR DISTRIBUTORS DASHBOARD
//FETCH INVOICES AND PAYMENTS API SERVICE
export const invoicePaymentData = (profileId, token) => {
    return axiosInstance.get(PAYMENT_TABLE_DATA_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//FETCH COMPLAINTS API SERVICE
export const complaintDataTable = (profileId, token) => {
    return axiosInstance.get(COMPLAINTS_TABLE_DATA_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//FETCH DSR WISE SALES API SERVICE
export const dsrWiseSalesData = (profileId, token) => {
    return axiosInstance.get(DSR_WISE_SALES_DATA_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//FETCH DSR WISE TARGET VS ACHIEVEMENT
export const skuWiseTargetVsAchievement = (profileId, token) => {
    return axiosInstance.get(TARGET_VS_ACHIEVEMENT_DATA_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//FETCH INVOICES DETAILS WITH GEO LOCATIONS
export const showInvoicesOnMap = (payload, token) => {
    return axiosInstance.post(INVOICES_AND_PAYMENTS_ON_THE_MAP, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FOR BACK OFFICE DASHBOARD
//FETCH MASTER DATA COUNTS
export const fetchDashboardCounts = (token, profileId) => {
    return axiosInstance.get(FETCH_DASHBOARD_COUNTS(profileId), {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH DISTRIBUTORS LIST
export const fetchDistributors = (profileId, token) => {
    return axiosInstance.get(FETCH_DISTRIBUTORS_LIST(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH INVOICE AND PAYMENTS
export const fetchInvoiceAndPayments = (payload, token) => {
    return axiosInstance.post(FETCH_INVOICE_AND_PAYMENTS, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
};

//FETCH ORDER REQUESTS
export const fetchOrderRequests = (profileId, token) => {
    return axiosInstance.get(FETCH_ORDER_REQUESTS(profileId), {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH DISTRIBUTOR STOCKS
export const fetchDistributorStocks = (payload, token) => {
    return axiosInstance.post(FETCH_DISTRIBUTOR_STOCKS, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
};

//FETCH ORGANIZATION STRUCTURE LIST
export const fetchOrgStructList = (token) => {
    return axiosInstance.get(FETCH_ORG_STRUCTURES_LIST, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH NEXT ORGANIZATION STRUCTURE LIST
export const fetchNextOrgStructList = (profileId, token) => {
    return axiosInstance.get(FETCH_NEXT_ORG_STRUCTURES_LIST(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH USERS IN THE SELECTED ORGANIZATION STRUCTURE
export const fetchUsersInOrgStructure = (orgStructId, token) => {
    return axiosInstance.get(FETCH_USERS_IN_ORG_STRUCTURE(orgStructId), {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH TARGET VS ACHIEVEMENTS
export const fetchTargetsVsAchievements = (payload, token) => {
    return axiosInstance.post(FETCH_TARGET_VS_ACHIEVEMENTS, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
};

//FETCH VEHICLES BY DISTRIBUTOR
export const fetchDistributorVehicles = (profileId, token) => {
    return axiosInstance.get(FETCH_VEHICLES_BY_DISTRIBUTOR_API(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DEALER VISITS
export const fetchDealerVisits = (profileId, token) => {
    return axiosInstance.get(FETCH_DEALER_VISITS(profileId), {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH COMPLAINTS
export const fetchComplaints = (profileId, token) => {
    return axiosInstance.get(FETCH_COMPLAINTS(profileId), {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH PRODUCTIVE STATS
export const fetchProductiveStats = (payload, token) => {
    return axiosInstance.post(FETCH_PRODUCTIVE_STATS, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

// FETCH CALL SUMMARY STATS
export const fetchCallSummaryStats = (payload,token,) => {
    return axiosInstance.post(FETCH_CALL_SUMMARY_STATS,payload, {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json"  }
        });
};

//FETCH LORRY WISE SALES
export const fetchLorryWiseSales = (payload, token) => {
    return axiosInstance.post(FETCH_LORRY_WISE_SALES, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH LORRY WISE SALES DETAILS
export const fetchLorryWiseSalesDetails = (payload, token) => {
    return axiosInstance.post(FETCH_LORRY_WISE_SALES_DETAILS, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH SKU WISE SALES STATS
export const fetchSkuWiseSalesStats = (payload, token) => {
    return axiosInstance.post(FETCH_SKU_WISE_SALES_STATS, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH SKU WISE SALES DETAILS
export const fetchSkuWiseSalesDetails = (payload, token) => {
    return axiosInstance.post(FETCH_SKU_WISE_SALES_DETAILS, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//DEALER AND COMPETITOR MAP APIS (NEW DASHBOARD)
//FETCH DEALER AND COMPETITOR GEO-LOCATIONS
export const fetchDealersAndCompetitors = (profileId, token) => {
    return axiosInstance.get(FETCH_DEALERS_AND_COMPETITORS_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FILTER DEALER AND COMPETITOR GEO-LOCATIONS
export const filterDealersAndCompetitors = (payload, token) => {
    return axiosInstance.post(FETCH_DEALERS_AND_COMPETITORS_FILTERING_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH BUSINESS TYPES LIST
export const fetchBusinessTypesList = (token) => {
    return axiosInstance.get(GET_BUSINESS_TYPE_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH NATURE OF BUSINESS LIST
export const fetchNatureOfBusinessList = (payload, token) => {
    return axiosInstance.post(GET_NATURE_OF_BUSINESS_LIST_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
}

//FETCH HOLIDAYS API SERVICE
export const fetchHolidaysData = (token) => {
    return axiosInstance.get(FETCH_HOLIDAYS_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//CREATE HOLIDAY API SERVICE
export const createHolidayData = (payload, token) => {
    return axiosInstance.post(CREATE_NEW_HOLIDAY, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//UPDATE HOLIDAY API SERVICE
export const updateHolidayData = (id, payload, token) => {
    return axiosInstance.post(UPDATE_HOLIDAY_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH WORKING DAYS API SERVICE
export const fetchWorkingDaysData = (token) => {
    return axiosInstance.get(FETCH_WORKING_DAYS_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE WORKING DAYS API SERVICE
export const saveWorkingDaysData = (payload, token) => {
    return axiosInstance.post(SAVE_WORKING_DAYS_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//----------------------------------- TRANSACTIONS API SERVICE -----------------------------------
//FETCH INVOICES FOR DISTRIBUTOR
export const fetchInvoicesByDistributor = (payload, token) => {
    return axiosInstance.post(INVOICE_BY_DISTRIBUTOR_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH FSM LIST API SERVICE (FOR DROPDOWNS)
export const fetchFsmList = (profileId, token) => {
    const url = FSM_LIST_API_URL(profileId);
    console.log(`Fetching FSM list from URL: ${url}`);
    return axiosInstance.get(url, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH ASM LIST API SERVICE (FOR DROPDOWNS)
export const fetchAsmList = (profileId, fsmId, token) => {
    return axiosInstance.get(ASM_LIST_API_URL(profileId, fsmId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DISTRIBUTOR LIST API SERVICE (FOR DROPDOWNS)
export const fetchDistributorList = (profileId, asmId, token) => {
    const url = DISTRIBUTOR_LIST_API_URL(profileId, asmId);
    console.log(`Fetching Distributor list from URL: ${url}`);
    return axiosInstance.get(DISTRIBUTOR_LIST_API_URL(profileId, asmId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DEALERS LIST API SERVICE (FOR DROPDOWNS)
export const fetchDealerList = (profileId, distributorId, token) => {
    return axiosInstance.get(DEALER_LIST_API_URL(profileId, distributorId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH USER LIST BY ROLE API
export const fetchUserListByRole = (profileId, roleId, token) => {
    return axiosInstance.get(USER_LIST_BY_ROLE_API(profileId, roleId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DEALERS API SERVICE
export const fetchDealerListManagement = (profileId, distributorId, token) => {
    return axiosInstance.get(DEALER_LIST_API_URL_MANAGEMENT(profileId, distributorId), {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//COMPLAINT FILTERING API SERVICE
export const searchComplaints = (params, token) => {
    return axiosInstance.post(COMPLAIN_DETAILS_API_URL, params, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//ORDERS FILTERING API SERVICE
export const searchOrder = (params, token) => {
    return axiosInstance.post(ORDER_SEARCH_API_URL, params, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//VIEW ORDER DETAILS API SERVICE
export const fetchOrderDetails = (id, token) => {
    return axiosInstance.get(ORDER_DETAILS_SEARCH_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE COMPLAINT API SERVICE (SEND REPLY FOR COMPLAINT)
export const updateComplaints = (params, token) => {
    return axiosInstance.post(COMPLAIN_UPDATE_API_URL, params, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH STOCK ALLOCATIONS API SERVICE
export const fetchAllocationList = (profileId, token, payload) => {
    console.log("API Payload:", payload); // Log the payload
    return axiosInstance.post(STOCK_ALLOCATION_LIST_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH DISTRIBUTOR STOCKS API SERVICE
export const fetchDistributorStockList = (profileId, token) => {
    return axiosInstance.get(FETCH_DISTRIBUTOR_STOCK_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH VEHICLES LIST API SERVICE (FOR DROPDOWNS)
export const fetchVehicleList = (profileId, token) => {
    return axiosInstance.get(VEHICLE_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DRIVERS AND HELPERS LIST API SERVICE (FOR DROPDOWNS)
export const fetchDriverHelperList = (staffType, profileId, token) => {
    return axiosInstance.get(DRIVER_HELPER_API_URL(staffType, profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH SALES TYPE LIST API SERVICE (FOR DROPDOWNS)
export const fetchSalesType = (companyId, token) => {
    return axiosInstance.get(SALES_TYPE_API_URL(companyId), {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//FETCH SALES REPS LIST API SERVICE (FOR DROPDOWNS)
export const fetchSalesRepList = (profileId, token) => {
    const url = SALES_REP_LIST_API_URL(profileId);
    console.log(`Fetching Sales Rep list from URL: ${url}`);

    return axiosInstance.get(SALES_REP_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//FETCH DEALER TYPE LIST API SERVICE (FOR DROPDOWNS)
export const fetchDealerTypeList = (profileId, token) => {
    return axiosInstance.get(DEALER_TYPE_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//FETCH ITEMS LIST API SERVICE (FOR ADD ITEMS TO STOCK ALLOCATION)
export const fetchItemNameList = (companyId, isparent, token) => {
    return axiosInstance.get(ITEMS_LIST_API_URL(companyId, isparent), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH ITEMS LIST PRICES API SERVICE
export const fetchItemPricesAndStock = (company_id, district_id, distributor_id, token) => {
    return axiosInstance.get(ITEMS_PRICES_AND_STOCK_API_URL(company_id, district_id, distributor_id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE STOCK ALLOCATION API SERVICE
export const saveStockAllocation = (payload, token) => {
    return axiosInstance.post(SAVE_STOCK_ALLOCATION_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH STOCK ADJUSTMENT REASONS
export const fetchAdjustmentReasons = (token) => {
    return axiosInstance.get(FETCH_ADJUSTMENT_REASONS_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//SAVE STOCK ADJUSTMENT API SERVICE
export const saveStockAdjustment = (payload, token) => {
    return axiosInstance.post(SAVE_STOCK_ADJUSTMENT_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

// FETCH STOCK ADJUSTMENT APPROVAL REQUEST LIST
// export const fetchStockAdjustmentApprovalList = (profileId, token) => {
//   return axiosInstance.get(FETCH_STOCK_ADJUSTMENT_APPROVAL_LIST_API_URL(profileId), {
//     headers: { Authorization: `Bearer ${token}` },
//   });
// };
export const fetchStockAdjustmentApprovalList = (profileId, token, params = {}) => {
    return axiosInstance.get(FETCH_STOCK_ADJUSTMENT_APPROVAL_LIST_API_URL(profileId), {
        params,
        headers: { Authorization: `Bearer ${token}` },
    });
};

// APPROVE OR REJECT STOCK ADJUSTMENT DETAIL ITEM
export const updateStockAdjustmentItemApproval = (detailId, payload, token) => {
    return axiosInstance.post(
        UPDATE_STOCK_ADJUSTMENT_ITEM_APPROVAL_API_URL(detailId),
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );
};

// FETCH STOCK ADJUSTMENT HISTORY LIST
// export const fetchStockAdjustmentHistoryList = (profileId, token) => {
//   return axiosInstance.get(FETCH_STOCK_ADJUSTMENT_HISTORY_LIST_API_URL(profileId), {
//     headers: { Authorization: `Bearer ${token}` },
//   });
// };
export const fetchStockAdjustmentHistoryList = (profileId, token, params = {}) => {
    return axiosInstance.get(FETCH_STOCK_ADJUSTMENT_HISTORY_LIST_API_URL(profileId), {
        params,
        headers: { Authorization: `Bearer ${token}` },
    });
};

//SAVE INITIAL STOCK API SERVICE
export const saveInitialStock = (payload, token) => {
    return axiosInstance.post(SAVE_INITIAL_STOCK_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH DRIVER AND HELPERS LIST FOR DROP DOWN IN DISPATCH
export const driverAndHelper = (staffType, profileId, token) => {
    return axiosInstance.get(DRIVER_HELPER_API_URL(staffType, profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//FETCH SIDE NAVIGATION ITEMS ACCORDING TO THE USER ROLE API SERVICE
export const getMenuItems = (profileId, token) => {
    return axiosInstance.get(MENU_LOAD_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FILTER DEALER VISITS API SERVICE
export const searchdealervisit = (params, token) => {
    return axiosInstance.post(DEALER_VISIT_API_URL, params, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};
//Fetch Dealer price 
export const fetchItemPricesAndStockByDealer = (dealerId, profileId, token) => {
    return axiosInstance.get(ITEMS_PRICES_AND_STOCK_BY_DEALER_API_URL(dealerId, profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DISPATCHES LIST API SERVICE
export const dispatchlist = (profileId, token) => {
    return axiosInstance.get(DISPATCH_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//VIEW DISPATCH ITEMS FOR SELECTED DISPATCH API SERVICE
export const dispatchlistitem = (dispatchNo, token) => {
    return axiosInstance.get(DISPATCH_ITEM_API_URL(dispatchNo), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//SAVE GATE PASS API SERVICE
export const savegetpass = (payload, token) => {
    return axiosInstance.post(GATE_PASS_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
};

// Get gate pass receipt
export const fetchGatePassReceipt = (gatePassId, token) => {
    console.log('🔗 Calling API with Gate Pass ID:', gatePassId);
    return axiosInstance.get(`/web/gatepass/receipt/${gatePassId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

//FETCH ROUTE LIST API SERVICE (FOR DROPDOWNS)
export const fetchRouteList = (profileId, token) => {
    return axiosInstance.get(ROUTE_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//FETCH SALES REP LIST FOR DISPATCH API SERVICE (FOR DROPDOWNS)
export const fetchREpDispatchList = (profileId, token) => {
    const url = DISPATCH_LIST_REP_API_URL(profileId);
    console.log(`Fetching Dispatch list from URL: ${url}`);
    return axiosInstance.get(DISPATCH_LIST_REP_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//SAVE DISPATCH API SERVICE
export const saveDispatch = (payload, token) => {
    return axiosInstance.post(SAVE_DISPATCH_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH DISPATCHES FOR GATE PASS IN PROCESS API SERVICE
export const dispatchlistout = (profileId, token) => {
    return axiosInstance.get(GATE_PASS_IN_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//VIEW ITEMS FOR SELECTED DISPATCH FOR GATE PASS IN PROCESS API SERVICE
export const dispatchlistitemout = (dispatchNo, token) => {
    return axiosInstance.get(GATE_PASS_IN_ITEM_API_URL(dispatchNo), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//SAVE GATE PASS IN API SERVICE
export const savegetpassin = (payload, token) => {
    return axiosInstance.post(GATE_PASS_API_URL_SAVE, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
};

//VIEW STOCK ALLOCATION DETAILS
export const fetchStockAllocationPopup = (id, token) => {
    return axiosInstance.get(STOCK_ALLOCATION_POPUP_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//VIEW DETAILS OF SELECTED STOCK ALLOCATION
export const fetchStockAllocationById = (id, token) => {
    return axiosInstance.get(STOCK_ALLOCATION_BY_ID_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//VIEW ITEMS IN DISPATCH UPDATE (EDIT DISPATCH)
export const dispatchupdateitems = (id, token) => {
    return axiosInstance.get(DISPATCH_UPDATE_ITEM_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//UPDATE DISPATCH API SERVICE
export const updatedispatchdetails = (id, payload, token) => {
    return axiosInstance.post(UPDATE_DISPATCH_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
};

//FETCH DISPATCHES FOR SHOW IN THE DISPATCH MAIN SCREEN
export const griddispatch = (payload, token) => {
    return axiosInstance.post(GRID_DISPATCH_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
};

//CANCEL DISPATCH
export const cancelDispatch = (token, payload) => {
    return axiosInstance.post(DISPATCH_CANCEL_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH SALES REP LIST RELATED TO THE DISPATCHES
export const dispatchreplist = (org, profileId, token) => {
    return axiosInstance.get(DISPATCH_REP_API_URL(org, profileId, profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE STOCK ALLOCATION API SERVICE
export const updateStockAllocation = (id, payload, token) => {
    return axiosInstance.post(UPDATE_STOCK_ALLOCATION_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH DAILY SALES RECORDS - FOR GENERATE DAILY SALES REPORT
export const fetchDailySaleReport = (params, token) => {
    return axiosInstance.post(DAILY_SALE_REPORT_API_URL, params, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH DETAILS OF THE SELECTED DEALER VISIT
export const fetchDealerPopup = (id, token) => {
    return axiosInstance.get(DEALER_POPUP_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DETAILS OF THE SELECTED INVOICE
export const fetchInvoiceDetails = (invoiceNo, token) => {
    const apiUrl = INVOICE_DETAILS_API_URL(invoiceNo);
    console.log(`API URL: ${apiUrl}`);

    return axiosInstance.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH VEHICLES LIST FOR GATE PASS
export const fetchVehicleListByProfile = (profileId, token) => {
    return axiosInstance.get(VEHICLE_LIST_BY_PROFILE_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH VEHICLES LIST FOR GATE PASS IN
export const fetchVehicleListByProfileGateIn = (profileId, token) => {
    return axiosInstance.get(VEHICLE_LIST_BY_GATEPASSIN_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//DISPATCH ITEMS LIST FOR GATE PASS
export const fetchDispatchItemsSearch = (payload, token) => {
    return axiosInstance.post(DISPATCH_ITEMS_SEARCH_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//SEARCH FOR DISPATCH ITEMS
export const fetchDispatchItemsSearchGatePassIn = (payload, token) => {
    return axiosInstance.post(DISPATCH_ITEMS_SEARCH_BY_GATEPASSIN_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH THE DETAILS OF SELECTED DISPATCH
export const fetchDispatchDetailsById = (id, token) => {
    return axiosInstance.get(VIEW_DISPATCH_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//EDIT DISPATCH
export const dispatcheditstock = (profileId, payload, token) => {
    return axiosInstance.post(DISPATCH_EDIT_STOCK_API_URL(profileId), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
};

//FETCH INVOICE SUMMARY
export const fetchInvoiceSummary = (payload, token) => {
    return axiosInstance.post(INVOICE_SUMMARY_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH DISTRIBUTORS LIST
export const fetchDistributorListInvoice = (profileId, token) => {
    const url = DISTRIBUTOR_LIST_INVOICE_API_URL(profileId);
    console.log(`Fetching Distributor list from URL: ${url}`);
    return axiosInstance.get(url, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH SALES REPS LIST (INVOICE SUMMARY SCREENS)
export const fetchRepListInvoice = (profileId, profileId1, token) => {
    const url = SALES_REP_LIST_INVOICE_API_URL(profileId, profileId1);
    console.log(`Fetching Rep list from URL: ${url}`);
    return axiosInstance.get(url, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DISTRIBUTORS LIST (PO AND LOST SALE REPORTS)
export const fetchDistributorListOrderRequestAll = (token) => {
    const url = DISTRIBUTOR_LIST_ORDER_REQUEST_API_URL_ALL();
    console.log(`Fetching Distributor list from URL: ${url}`);
    return axiosInstance.get(url, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DISTRIBUTORS LIST FOR DROP DOWN IN PURCHASE ORDER REQUEST
export const fetchDistributorListOrderRequest = (profileId, token) => {
    const url = DISTRIBUTOR_LIST_ORDER_REQUEST_API_URL(profileId);
    console.log(`Fetching Distributor list from URL: ${url}`);
    return axiosInstance.get(url, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH VEHICLES LIST FOR DROP DOWN IN PURCHASE ORDER REQUEST
export const fetchVehicleListOrderRequest = (profileId, token) => {
    return axiosInstance.get(VEHICLE_LIST_ORDER_REQUEST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//FETCH PLANTS FOR DROP DOWN IN PURCHASE ORDER REQUEST
export const fetchPlantOrderRequest = (token) => {
    return axiosInstance.get(PLANT_LIST_ORDER_REQUEST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH BRIDGING TYPES FOR DROP DOWN IN PURCHASE ORDER REQUEST
export const fetchBridgingList = (token) => {
    return axiosInstance.get(BRIDGING_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE PURCHASE ORDER (PO)
export const savePurchaseOrder = (payload, token) => {
    return axiosInstance.post(SAVE_PURCHASE_ORDER_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
};

//FETCH PURCHASE ORDER (PO) LIST IN PO HOME SCREEN WITH OPTIONAL FORMDATE
export const fetchPurchaseOrderList = (token, profileId, formdate = null) => {
    const requestData = {
        profile_id: profileId,
        ...(formdate && { formdate }) // Only include formdate if it's provided
    };

    return axiosInstance.post(PURCHASE_ORDER_LIST_API_URL, requestData, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
};

//FETCH PURCHASE ORDER (PO) LIST IN PO HOME SCREEN
/*export const fetchPurchaseOrderList = (token, formdate) => {
    return axiosInstance.post(PURCHASE_ORDER_LIST_API_URL, { formdate }, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};*/

//FETCH PURCHASE ORDER (PO) DETAILS FOR EDIT
export const fetchPurchaseOrderDetails = (id, token) => {
    return axiosInstance.get(PURCHASE_ORDER_DETAILS_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE PURCHASE ORDER (PO)
export const updatePurchaseOrder = (id, payload, token) => {
    return axiosInstance.post(PURCHASE_ORDER_UPDATE_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH SELECTED PURCHASE ORDER DETAILS IN POPUP MODAL
export const fetchPurchaseOrderPopup = (id, token) => {
    return axiosInstance.get(PURCHASE_ORDER_POPUP_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH VEHICLE TYPES
export const fetchVehicleType = (token) => {
    return axiosInstance.get(BRIDGING_TYPE_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH ORDER SCHEDULE (PO) LIST
export const fetchOrderScheduleList = (token, { distributor_id = null, formdate = null, gas_plant_id = null }) => {
    return axiosInstance.post(PO_SHEDULE_LIST_API_URL, {
        distributor_id,
        formdate,
        gas_plant_id
    }, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH PURCHASE ORDER LIST
export const fetchPoList = (profileId, token) => {
    return axiosInstance.get(PO_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//FILTER GOODS RECEIVED NOTE (GRN) FOR GIVEN CRITERIA
export const grnsearch = (params, token) => {
    return axiosInstance.post(GRN_SEARCH_API_URL, params, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//SAVE GOODS RECEIVED NOTE (GRN)
export const grnsave = (payload, token) => {
    return axiosInstance.post(GRN_SAVE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH GOODS RECEIVED NOTE (GRN) LIST IN GRN HOME SCREEN
export const fetchGrnList = (token, payload) => {
    return axiosInstance.post(GRN_LIST_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//VIEW SELECTED GOODS RECEIVED NOTE (GRN) DETAILS IN POPUP MODAL
export const fetchGrnDetailsPopup = (id, token) => {
    return axiosInstance.get(GRN_POPUP_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH GOODS RECEIVED NOTE (GRN) DETAILS FOR EDIT
export const fetchGrnDetailsList = (id, token) => {
    return axiosInstance.get(GRN_DETAILS_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//VIEW GOODS RECEIVED NOTE (GRN) REPORT
export const Grnallpolist = (profileId, token) => {
    return axiosInstance.get(GRN_ALL_PO_LIST(profileId), {
        headers: { Authorization: `Bearer ${token}` },
    });
};

//UPDATE GOODS RECEIVED NOTE (GRN)
export const updateGrn = (id, payload, token) => {
    return axiosInstance.post(GRN_UPDATE_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//PURCHASE ORDER APPROVE
export const poshappvoal = (payload, token) => {
    return axiosInstance.post(PO_SH_APPROVE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//PURCHASE ORDER SCHEDULE EDIT
export const poshreject = (payload, token) => {
    return axiosInstance.post(PO_SH_REJECT_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//PURCHASE ORDER SCHEDULE SUMMARY REPORT
export const PurchaseOrderScheduleSummary = (params, token) => {
    return axiosInstance.post(PO_SCH_REPORT_API_URL, params, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH DATA TO THE DISTRIBUTOR LOST SALE REPORT
export const fetchReportLossSale = (params, token) => {
    return axiosInstance.post(REPORT_LOSS_SALE_API_URL, params, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH DISTRIBUTOR STOCKS
export const fetchdistributorstocks = (params, token) => {
    return axiosInstance.post(REPORT_DISTRIBUTOR_STOCK_API_URL, params, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH ITEMS LIST ON ORDER REQUEST EDIT FORM
export const fetchItemNameListOrderEditAllItem = (companyId, isparent, token) => {
    return axiosInstance.get(ITEMS_LIST_ORDER_API_URL(companyId, isparent), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH ITEM LIST API SERVICE
export const fetchItemNameListOrder = (companyId, isparent, token) => {
    return axiosInstance.get(ITEMS_LIST_ORDER_API_URL(companyId, isparent), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DISTRIBUTORS LIST API SERVICE
export const fetchDistributorsList = (profileId, token) => {
    return axiosInstance.get(FETCH_DISTRIBUTORS_LIST_API(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH SALES ROUTE LIST API SERVICE
export const fetchSalesRoute = (profileId, token) => {
    return axiosInstance.get(SALE_ROUTE_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH VEHICLE WISE STOCK API SERVICE
export const vehicelwisestockrepoet = (payload, token) => {
    return axiosInstance.post(VEHICLE_STOCK_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH SALES REP LIST FOR SELECTED DISTRIBUTOR (FOR DISPATCH MAIN SCREEN)
export const fetchSalesReps = (profileId, distributorId, token) => {
    return axiosInstance.get(FETCH_SALES_REPS_LIST(profileId, distributorId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//CANCEL INVOICE API SERVICE
export const cancelInvoice = (payload, token) => {
    return axiosInstance.post(CANCEL_INVOICE, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//----------------------------------- MASTER DATA API SERVICES -----------------------------------
//ITEMS MODULE
export const fetchAllItemsList = (companyId, token) => {
    return axiosInstance.get(FETCH_ALL_ITEM_API(companyId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH ITEMS LIST API SERVICE
export const fetchItemsList = (companyId, token) => {
    return axiosInstance.get(ITEM_LIST_API(companyId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DISTRICT LIST API SERVICE
export const fetchDistrictsList = (token) => {
    return axiosInstance.get(DISTRICT_LIST_API, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE ITEM PRICE API SERVICE
export const saveItemPrice = (payload, token) => {
    return axiosInstance.post(ITEM_PRICE_SAVE_API, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FILTER ITEM PRICE UPDATES API SERVICE
export const searchItemPrices = (payload, token) => {
    return axiosInstance.post(SEARCH_ITEM_PRICES_API, payload, { // Empty object as the request body
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//VIEW ITEM PRICES API SERVICE
export const viewItemPrices = (id, token) => {
    return axiosInstance.get(VIEW_ITEM_PRICES_API(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//ITEM PRICE APPROVE OR REJECT API SERVICE
export const itemPriceConfirm = (id, payload, token) => {
    return axiosInstance.post(ITEM_PRICE_CONFIRM_API(id), payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//----------------------------------- USER AND ROLE MANAGEMENT API SERVICES -----------------------------------
//SAVE USER ROLE
export const saveUser = (token, payload) => {
    return axiosInstance.post(USER_ROLE_SAVE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH USER ROLE LIST
export const fetchUserRoleList = (profileId, token) => {
    console.log("API Payload:", profileId); // Log the payload
    return axiosInstance.get(`${USER_ROLE_LIST_API_URL}?profileId=${profileId}`, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH USER ROLE BY ID
export const fetchUserRoleById = (id, token) => {
    return axiosInstance.get(USER_ROLE_API_BY_ID_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE USER ROLE
export const updateRole = (id, token, payload) => {
    return axiosInstance.post(USER_ROLE_UPDATE_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH USER ROLE BY NAME
export const fetchUserRoleByName = (payload, token) => {
    return axiosInstance.post(USER_ROLE_BY_NAME_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH ROUTE LIST AS MODULES
export const fetchRouteListAsModules = (token) => {
    return axiosInstance.get(ROUTE_LIST_AS_MODULES_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE MODULE ROUTE
export const saveModuleRoute = (token, payload) => {
    return axiosInstance.post(MODULE_ROUTE_SAVE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH USER ACCESS BY ROLE ID
export const fetchUserAccessByRoleId = (id, token) => {
    return axiosInstance.get(USER_ACCESS_BY_ROLE_ID_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE USER ROLE DETAILS
export const saveUserRoleDeatils = (token, payload) => {
    return axiosInstance.post(USER_ROLE_DETAILS_SAVE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH USER ROLE DETAILS BY ROLE ID
export const fetchUserRoleDetailsByRoleId = (id, token) => {
    return axiosInstance.get(USER_ROLE_DETAILS_GET_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE USER ROLE DETAILS
export const updateUserRole = (token, payload) => {
    return axiosInstance.post(USER_ROLE_DEATILS_UPDATE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//VIEW USER ROLE DETAILS BY ID
export const viewUserRoleDetails = (id, token) => {
    return axiosInstance.get(USER_ROLE_DETAILS_VIEW_BY_ID_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH MODULE WISE USER NAMES BY ID
export const ViewModuleWiseUserNamesById = (id, token) => {
    return axiosInstance.get(MODULE_WISE_USER_NAMES_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH USER ROLE LIST FOR USER FORM
export const fetchUserRoleListForUserForm = (token) => {
    return axiosInstance.get(USER_ROLE_LIST_FOR_USERS_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH ORG STRUCTURE LIST FOR USER FORM
export const fetchOrgStructureListForUserForm = (token) => {
    return axiosInstance.get(ORG_STRUCTURE_LIST_FOR_USERS_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH REPORTING TO LIST FOR USER FORM
export const fetchReportingToListForUserForm = (token, id) => {
    return axiosInstance.get(REPORTING_LIST_BY_ORG_ID_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE USER DETAILS
export const saveUserDeatils = (token, payload) => {
    return axiosInstance.post(USER_CREATE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH COMPANY LIST FOR USER FORM
export const fetchCompanyListForUserForm = (token) => {
    return axiosInstance.get(Company_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DISTRICT LIST FOR USER FORM
export const fetchDistrictListForUserForm = (token) => {
    return axiosInstance.get(DISTRICT_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH USERS LIST
export const fetchUsersList = (token) => {
    return axiosInstance.get(USER_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH USER DETAILS BY ROLE ID
export const fetchUserDetailsByRoleId = (id, token) => {
    return axiosInstance.get(USERS_DETAILS_GET_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE USER DETAILS
export const updateUser = (id, token, payload) => {
    return axiosInstance.post(USER_UPDATE_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//VIEW USER DETAILS BY ID
export const ViewUserDetailsById = (id, token) => {
    return axiosInstance.get(USER_DETAILS_BY_ID_VIEW_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UNBLOCK USER API SERVICE
export const unblockUser = (userId, token) => {
    return axiosInstance.get(USER_UNBLOCK_API_URL(userId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//----------------------------------- ITEM MODULE API SERVICES -----------------------------------
//GET ITEM TYPE LIST
export const fetchItemType = (token) => {
    return axiosInstance.get(ITEM_TYPE_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//----------------------------------- ITEM MASTER MODULE API SERVICES -----------------------------------
//CREATE NEW ITEM API SERVICE
export const createNewItem = (token, payload) => {
    return axiosInstance.post(CREATE_NEW_ITEM_API_URL, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    });
};

//GET ITEM DETAILS API SERVICE
export const getItemDetails = (token, id) => {
    return axiosInstance.get(GET_ITEM_DETAILS_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//EDIT ITEM API SERVICE
export const editItem = (token, payload) => {
    return axiosInstance.post(EDIT_ITEM_API_URL, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    });
};

//CREATE NEW ITEM
export const saveItemDetails = (token, payload) => {
    return axiosInstance.post(ITEM_SAVE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET UNIT OF MEASUREMENT LIST
export const fetchUOM = (token) => {
    return axiosInstance.get(UOM_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET ITEM CODE FOR NEW ITEM
export const fetchItemCode = (token) => {
    return axiosInstance.get(ITEM_CODE_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET ITEM DETAILS FOR EDIT
export const editItemDetailsById = (id, token) => {
    return axiosInstance.get(ITEM_EDIT_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//VIEW ITEM DETAILS BY ID
export const ViewItemsDetailsById = (id, token) => {
    return axiosInstance.get(ITEM_DETAILS_VIEW_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE ITEM DETAILS
export const updateItem = (id, token, payload) => {
    return axiosInstance.post(ITEM_UPDATE_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//CREATE NEW ITEM VARIANT
export const saveItemVariantDetails = (token, payload) => {
    return axiosInstance.post(ITEM_VARIANT_SAVE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//GET ITEM VARIANT DETAILS BY ID
export const ItemVariantDetailsById = (id, token) => {
    return axiosInstance.get(ITEM_DETAILS_VIEW_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//ITEM VARIANT UPDATE API
export const updateVariant = (id, token, payload) => {
    return axiosInstance.post(ITEM_VARIANT_UPDATE_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//ITEM LIST API
export const fetchItemVariantList = (token) => {
    return axiosInstance.get(ITEM_VARIANT_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//----------------------------------- DEALER MODULE API SERVICES -----------------------------------
//GET ALL DEALERS ACCORDING TO SELECTED DISTRIBUTORS
export const fetchDealersByDistributors = (id, token) => {
    return axiosInstance.get(FETCH_DEALERS_BY_DISTRIBUTORS_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//VIEW DEALER DETAILS
export const viewDealerDetails = (id, token) => {
    return axiosInstance.get(VIEW_DEALER_DETAILS_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//CREATE NEW DEALER
export const createNewDealer = (payload, token) => {
    return axiosInstance.post(CREATE_NEW_DEALER_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//UPDATE DEALER DETAILS
export const updateDealer = (id, token, payload) => {
    return axiosInstance.post(UPDATE_DEALER_DETAILS_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//VERIFY DEALER DETAILS
export const verifyDealer = (id, token) => {
    return axiosInstance.patch(VERIFY_DEALER_DETAILS_API_URL(id), {}, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DEALER GROUPS
export const getDealerGroups = (profileId, token) => {
    return axiosInstance.get(FETCH_DEALER_GROUPS_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH DEALERS BY GROUPS
export const getDealersByGroup = (groupId, token) => {
    return axiosInstance.get(FETCH_DEALERS_BY_GROUPS_API_URL(groupId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//LOAD DEALER CATEGORY LIST
export const fetchDealerCategoryList = (token) => {
    return axiosInstance.get(DEALER_CATEGORY_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//LOAD DISTRIBUTOR LIST ACCORDING TO LOGIN USER
export const getDistributorList = (id, token) => {
    return axiosInstance.get(FETCH_DISTRIBUTORS_LIST_API(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//----------------------------------- DEALER ROUTE MAPPING MODULE API SERVICES -----------------------------------
//GET ALL ROUTE NAME LIST
export const fetchAllRouteList = (token) => {
    return axiosInstance.get(SALE_ROUTE_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET DEALER ROUTE LIST
export const fetchDealerRouteList = (token, payload) => {
    return axiosInstance.post(FETCH_DEALER_ROUTE_LIST_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//UPDATE DEALER ROUTE
export const saveUpdatedDealers = (token, payload) => {
    return axiosInstance.post(UPDATE_DEALER_ROUTE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//----------------------------------- TARGET MODULE API SERVICES -----------------------------------
//SAVE TARGET VS ACHIEVEMENTS API SERVICE
export const saveTarget = (payload, token) => {
    return axiosInstance.post(SAVE_TARGET_VS_ACHIEVEMENTS_API, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//DOWNLOAD TARGET TEMPLATE API SERVICE
export const downloadTarget = (profileId, token) => {
    return axiosInstance.get(DOWNLOAD_TARGET_API(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//DOWNLOAD TARGET MATRIX TEMPLATE API SERVICE
export const downloadTargetMatrix = (payload, token) => {
    return axiosInstance.post(DOWNLOAD_TARGET_MATRIX_API, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//TARGETS LIST API SERVICE
export const targetsList = (payload, token) => {
    return axiosInstance.post(TARGETS_LIST_API, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//VIEW TARGET API SERVICE
export const viewTargets = (id, token) => {
    return axiosInstance.get(VIEW_TARGET_API(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//LORRY TARGETS LIST API SERVICE
export const fetchLorryTargets = (payload, token) => {
    return axiosInstance.post(LORRY_TARGETS_API, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//DOWNLOAD TARGET MATRIX TEMPLATE API SERVICE
export const downloadLorryTargetMatrix = (payload, token) => {
    return axiosInstance.post(DOWNLOAD_LORRY_TARGET_API, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//SAVE LORRY TARGET API SERVICE
export const saveLorryTarget = (payload, token) => {
    return axiosInstance.post(SAVE_LORRY_TARGET_API, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//TARGETS SUMMARY API SERVICE
export const targetsSummary = (payload, token) => {
    return axiosInstance.post(TARGETS_SUMMARY_API, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//----------------------------------- DISTRIBUTOR STAFF MODULE API SERVICES -----------------------------------
//STAFF TYPE API SERVICE
export const fetchStaffType = (token) => {
    return axiosInstance.get(STAFF_TYPE_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//STAFF SAVE API SERVICE
export const saveStaffDetails = (token, payload) => {
    return axiosInstance.post(STAFF_SAVE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH STAFF LIST API SERVICE
export const fetchAllStaffList = (profileId, token) => {
    return axiosInstance.get(FETCH_ALL_STAFF_API(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//EDIT STAFF DETAILS API SERVICE
export const editStaffDetailsById = (id, token) => {
    return axiosInstance.get(STAFF_EDIT_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE STAFF API SERVICE
export const updateStaffDetails = (staffId, token, payload) => {
    return axiosInstance.post(STAFF_UPDATE_API_URL(staffId), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//VIEW STAFF DETAILS API SERVICE
export const viewStaffDetailsById = (id, token) => {
    return axiosInstance.get(STAFF_DETAILS_VIEW_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//----------------------------------- PROMOTION API SERVICES -----------------------------------
//FETCH ALL PROMOTIONS LIST
export const fetchAllPromotions = (token, id) => {
    return axiosInstance.get(PROMOTIONS_LIST_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//VIEW PROMOTION DETAILS
export const viewPromotionDetails = (id, token) => {
    return axiosInstance.get(VIEW_PROMOTION_DETAILS_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//PROMOTION PRIORITY MANAGEMENT
export const promotionPriority = (token, payload) => {
    return axiosInstance.post(PROMOTION_PRIORITY_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//GET DEALERS LIST
export const getAllDealers = (token, id) => {
    return axiosInstance.get(DEALERS_LIST_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE PROMOTION
export const savePromotion = (token, payload) => {
    return axiosInstance.post(SAVE_PROMOTION_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//UPDATE PROMOTION
export const updatePromotion = (id, token, payload) => {
    return axiosInstance.post(UPDATE_PROMOTION_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//GET COMPANY WISE ITEMS
export const getPromotionItemsList = (id, token) => {
    return axiosInstance.get(GET_ITEMS_LIST_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//PROMOTION ACTIVATE/DEACTIVATE
export const activePromotion = (id, token, payload) => {
    return axiosInstance.post(PROMOTION_ACTIVE_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//REVIEW PROMOTION
export const reviewPromotion = (id, token, payload) => {
    return axiosInstance.post(REVIEW_PROMOTION_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//GET ALL PROMOTIONS LIST
export const getAllPromotionsList = (token) => {
    return axiosInstance.get(GET_ALL_PROMOTIONS_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//----------------------------------- DISTRIBUTOR BANK API SERVICES -----------------------------------
//GET BRANCH LIST BY ID
export const fetchBranchList = (payload, token) => {
    return axiosInstance.post(BRANCH_LIST_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//BANK SAVE API SERVICE
export const saveBankDetails = (token, payload) => {
    return axiosInstance.post(BANK_SAVE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//FETCH BANKS API SERVICE
export const fetchAllBanksList = (profileId, token) => {
    return axiosInstance.get(GET_BANKS_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//EDIT BANK DETAILS API SERVICE
export const editBankDetailsById = (id, token) => {
    return axiosInstance.get(BANK_EDIT_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE BANK API SERVICE
export const updateBankDetails = (bankId, token, payload) => {
    return axiosInstance.post(BANK_UPDATE_API_URL(bankId), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//----------------------------------- DISTRIBUTOR VEHICLE API SERVICES -----------------------------------
//FETCH ALL VEHICLES LIST BY PROFILE ID
export const fetchAllVehiclesList = (profileId, token) => {
    return axiosInstance.get(`/vehicles/${profileId}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH VEHICLE TYPE LIST FOR DROPDOWN
export const getVehicleTypeList = (token) => {
    return axiosInstance.get(`/vehicle-type`, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE NEW VEHICLE API SERVICE
export const saveVehicleDetails = (token, payload) => {
    return axiosInstance.post(`/vehicles`, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//GET VEHICLE DETAILS BY ID FOR EDIT
export const getVehicleDetailsById = (id, token) => {
    return axiosInstance.get(`/vehicle/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE VEHICLE DETAILS API SERVICE
export const updateVehicleDetails = (vehicleId, token, payload) => {
    return axiosInstance.put(`/vehicle/${vehicleId}`, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//----------------------------------- ROUTE MODULE API SERVICES -----------------------------------
//GET ROUTES LIST BY PROFILE ID
export const fetchRoutesList = (token, profileId) => {
    return axiosInstance.get(GET_ROUTES_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//VIEW ROUTE DETAILS
export const viewRouteDetails = (token, routeId) => {
    return axiosInstance.get(VIEW_ROUTE_DETAILS_API_URL(routeId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//ADVANCE VIEW ROUTE DETAILS
export const advanceViewRouteDetails = (token, routeId) => {
    return axiosInstance.get(ADVANCE_VIEW_ROUTE_DETAILS_API_URL(routeId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET DEALERS LIST
export const getDealersList = (token, profileId) => {
    return axiosInstance.get(GET_DEALERS_ROUTES_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//CREATE NEW ROUTE
export const createNewRoute = (token, payload) => {
    return axiosInstance.post(CREATE_NEW_ROUTE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//EDIT ROUTE DETAILS
export const editRouteDetails = (token, payload) => {
    return axiosInstance.post(EDIT_ROUTE_DETAILS_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//----------------------------------- PAYMENT MANAGEMENT MODULE API SERVICES -----------------------------------
//ROUTER LIST ACCORDING TO LOGGING USER
export const fetchRouteListByLoginUser = (profile_id, token) => {
    return axiosInstance.get(ROUTER_LIST_BY_LOGGING_USER_API_URL(profile_id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET INVOICE PAYMENT DETAILS
export const invoicePaymentDetails = (payload, token) => {
    return axiosInstance.post(INVOICE_PAYMENT_DETAILS, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
}

//GET DEALER FINANCIALS DETAILS
export const getDealerFinancials = (payload, token) => {
    return axiosInstance.post(DEALER_FINANCIALS_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
}

//GET DEALER LIST ACCORDING TO THE SELECTED ROUTE
export const getdealerlistbyroute = (routeId, token) => {
    return axiosInstance.get(DEALER_LIST_BY_ROUTE_API_URL(routeId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET DEALER LIST ACCORDING TO THE LOGGING USER
export const getdealerlistbyloginuser = (profile_id, token) => {
    return axiosInstance.get(DEALER_LIST_BY_LOGGING_USER_API_URL(profile_id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH ALL BANK LIST
export const getBankList = (token) => {
    return axiosInstance.get(GET_BANK_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH BANK BRANCH LIST
export const getBankBranchList = (token) => {
    return axiosInstance.get(GET_BRANCH_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//COMPLETE INVOICE DUE PAYMENT SAVE API
export const saveCompletedDue = (payload, token) => {
    return axiosInstance.post(SAVE_INVOICE_PAYMENT, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//GET INVOICE PAYMENTS DETAILS ACCORDING TO THE INVOICE NUMBER
export const getInvoicePaymentsByInvoiceNo = (invoice_no, token) => {
    return axiosInstance.get(GET_INVOICE_PAYMENT_DETAILS_API_URL(invoice_no), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//UPDATE INVOICE PAYMENT DETAILS
export const updateInvoicePaymentDetails = (id, token, payload) => {
    return axiosInstance.post(UPDATE_INVOICE_PAYMENT_DETAILS_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET BRANCHES ACCORDING TO SELECTED BANK
export const getBranchesByBankId = (payload, token) => {
    return axiosInstance.post(GET_BRANCHES_BY_BANKS_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//GET DEALERS ACCORDING TO THE SELECTED ROUTE
export const getDealersByRoute = (routeId, token) => {
    return axiosInstance.post(GET_DEALERS_BY_ROUTE_API_URL,
        { route_id: routeId },
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
};

//GET BANKS ACCORDING TO THE LOGIN USER
export const getBanksByLoginUser = (profile_id, token) => {
    return axiosInstance.get(GET_BANKS_BY_LOGIN_USER_API_URL(profile_id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//CANCEL INVOICE PAYMENT
export const cancelInvoicePayment = (id, token, payload) => {
    return axiosInstance.post(CANCEL_INVOICE_PAYMENT_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//BULK CANCEL INVOICE PAYMENTS
export const bulkCancelInvoicePayments = (payload, token) => {
    return axiosInstance.post(BULK_CANCEL_INVOICE_PAYMENT_API_URL, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
};

//GET ADVANCE PAYMENTS ACCORDING TO THE SELECTED DEALER
export const getAdvancePaymentsByDealer = (id, token) => {
    return axiosInstance.get(GET_ADVANCE_PAYMENTS_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET ADVANCE PAYMENTS BY FILTER
export const getAdvancePaymentDetails = (payload, token) => {
    return axiosInstance.post(GET_ADVANCE_PAYMENTS_FILTER_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET ADVANCE PAYMENT DETAILS BY ID
export const getAdvancePaymentDetailsById = (id, token) => {
    return axiosInstance.get(GET_ADVANCE_PAYMENT_DETAILS_BY_ID_API_URL(id), {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

//SAVE NEW ADVANCE PAYMENT
export const saveNewAdvancePayment = (token, payload) => {
    return axiosInstance.post(SAVE_NEW_ADVANCE_PAYMENT_API_URI, payload, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//CANCEL ADVANCE PAYMENT
export const cancelAdvancePayment = (id, token, payload) => {
    return axiosInstance.post(CANCEL_ADVANCE_PAYMENTS_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//UPDATE ADVANCE PAYMENT
export const updateAdvancePayment = (id, token, payload) => {
    return axiosInstance.post(UPDATE_ADVANCE_PAYMENTS_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//SAVE INVOICE PAYMENTS
export const saveCompletedPay = (payload, token) => {
    return axiosInstance.post(SAVE_INVOICE_PAYMENTS_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE GUEST INVOICE & PAYMENT
export const saveCustomerInvoice = (payload, token) => {
    return axiosInstance.post(SAVE_CUSTOMER_INVOICE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//----------------------------------- REPORTS MODULE API SERVICES -----------------------------------
//DAY END REPORT API SERVICE
export const fetchDayEndReport = (token, params) => {
    return axiosInstance.post(DAY_END_REPORT_API_URL, params, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//DISTRIBUTOR WISE DEALER REPORT API SERVICE
export const fetchDisdeaReport = (token, params) => {
    return axiosInstance.post(DIS_WISE_DEA_REPORT_API_URL, params, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//DISTRIBUTOR WISE SALES REPORT API SERVICE
export const fetchDissaleReport = (token, params) => {
    return axiosInstance.post(DIS_WISE_SAL_REPORT_API_URL, params, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

//ASM FSM WISE SALES REPORT API SERVICE
export const fetchAsmFsmWiseReport = (token, payload) => {
    return axiosInstance.post(ASM_FSM_WISE_SAL_REPORT_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//DEALER STATEMENT REPORT API SERVICE
export const fetchDealerStatementReport = (token, payload) => {
    return axiosInstance.post(DEA_STATE_SAL_REPORT_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//Distributor wise dealer stock report API service
export const fetchDistributorWiseDealerStockReport = (token, payload) => {
    return axiosInstance.post(DIS_WISE_DEA_STOCK_REPORT_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//Daily sales monitoring report API service
export const fetchDailySalesMonitoringReport = (token, payload) => {
    return axiosInstance.post(DAILY_SAL_MONITOR_REPORT_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//dealer vat report API service
export const fetchDealerVatReport = (token, payload) => {
    return axiosInstance.post(DEALER_VAT_REPORT_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH VEHICLE REPS LIST
export const fetchVehicleListrep = (profileId, token) => {
    return axiosInstance.get(VEHICLE_REP_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//STOCK RETURN REPORT API SERVICE
export const fetchStockReturnReport = (token, payload) => {
    return axiosInstance.post(STOCK_RETURN_REPORT_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//CASH BALANCING REPORT API SERVICE
export const fetchCashBalancingReport = (token, date, createdBy) => {
    return axiosInstance.get(`${CASH_BALANCING_REPORT_API_URL}?date=${date}&created_by=${createdBy}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//FETCH CASH BALANCING USERS API SERVICE
export const fetchCashBalancingUsers = (profileId, token) => {
    return axiosInstance.get(FETCH_CASH_BALANCING_USERS_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//AGEING ANALYSIS REPORT API SERVICE
export const fetchAgeingAnalysisReport = (token, payload) => {
    return axiosInstance.post(GET_AGEING_ANALYSIS_REPORT_API, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//----------------------------------- REAL TIME GPS TRACKING MODULE API SERVICES -----------------------------------
//GET USER GPS TRACKING SCHEDULE BASED ON LOGGED IN USER PROFILE ID
export const getGPSTrackingSchedule = (token, profileId) => {
    return axiosInstance.get(GET_USER_GPS_DATA_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//SAVE USER GPS TRACKING SCHEDULE
export const saveGPSTrackingSchedule = (token, payload) => {
    return axiosInstance.post(SAVE_GPS_TRACKING_SCHEDULE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//GET REPORTING USERS LIST
export const getReportingUsersList = (token, profileId) => {
    return axiosInstance.get(GET_REPORTING_USERS_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET MOBILE APP USER TYPES
export const getMobileAppUserTypes = (token, pageTypeId) => {
    return axiosInstance.get(GET_MOBILE_APP_USER_TYPES_API_URL(pageTypeId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET USERS BY TYPE
export const getUsersByType = (token, profileId, type) => {
    return axiosInstance.get(GET_USERS_BY_TYPE_API_URL(profileId, type), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

//GET LOCATIONS HISTORY
export const getLocationsHistory = (token, payload) => {
    return axiosInstance.post(GET_LOCATIONS_HISTORY_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//GET ROUTES WITH THEIR ASSIGNED DEALERS BY DISTRIBUTOR ID
export const fetchRoutesWithDealers = (token, distributorId) => {
    return axiosInstance.get(GET_ROUTES_WITH_DEALERS_API_URL(distributorId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

// FETCH OPEN STOCK BY ITEM ID
export const fetchOpenStockByItemId = (itemId, distributorId, token) => {
    return axiosInstance.get(FETCH_OPEN_STOCK_BY_ITEM_API_URL(itemId, distributorId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

// SAVE DAILY SCHEDULE
export const saveDailySchedule = (token, payload) => {
    return axiosInstance.post(SAVE_DAILY_SCHEDULE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

// FETCH DELIVERY SCHEDULE LIST
export const fetchDeliveryScheduleList = (payload, token) => {
    return axiosInstance.post(FETCH_DELIVERY_SCHEDULE_LIST_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

//----------------------------------- DEALER GROUP MODULE API SERVICES -----------------------------------

// GET DEALER GROUPS LIST
export const getDealerGroupsList = (token, profileId) => {
    return axiosInstance.get(GET_DEALER_GROUPS_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

// VIEW DEALER GROUP DETAILS
export const viewDealerGroupDetails = (id, token) => {
    return axiosInstance.get(VIEW_DEALER_GROUP_DETAILS_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

// GET DEALERS LIST (FOR CREATE NEW DEALER GROUP)
export const getAllDealersList = (token, profileId) => {
    return axiosInstance.get(GET_DEALERS_LIST_API_URL(profileId), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

// CREATE DEALER GROUP
export const createDealerGroup = (payload, token) => {
    return axiosInstance.post(CREATE_DEALER_GROUP_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
};

// FETCH FULL DETAILS OF THE DEALER GROUP - GROUP DETAILS, ASSIGNED DEALERS, UNASSIGNED DEALERS, OTHER DEALERS
export const advancedViewDealerGroup = (id, token) => {
    return axiosInstance.get(ADVANCED_DEALER_GROUP_VIEW_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
};

// EDIT DEALER GROUP
export const editDealerGroup = (payload, token) => {
    return axiosInstance.post(EDIT_DEALER_GROUP_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    })
};

export const GetDealerListByDistributorIndividualDealerCategory = (payload, token) => {
    return axiosInstance.post(
        GET_DEALER_LIST_BY_DISTRIBUTOR_INDIVIDUAL_DEALER_CATEGORY_API_URL,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        },
    );
};

/*
 * Loads Nature of Business options after selecting:
 *
 * Distributor
 * Individual category
 * Dealer Type / Commercial
 */
export const getNatureOfBusinessByDistributorDealerCategory = (
    payload,
    token,
) => {
    return axiosInstance.post(
        GET_NATURE_OF_BUSINESS_BY_DISTRIBUTOR_DEALER_CATEGORY_API_URL,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        },
    );
};

/*
 * Loads the final dealer dropdown after selecting
 * a Nature of Business.
 */
export const getDealersByDistributorCategoryNature = (
    payload,
    token,
) => {
    return axiosInstance.post(
        GET_DEALERS_BY_DISTRIBUTOR_CATEGORY_NATURE_API_URL,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        },
    );
};



export const getDealerCategories = (token) => {
    return axiosInstance.get(DEALER_CATEGORIES_API_URL, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

//CREDIT NOTE REPORT API SERVICE
export const fetchCreditNoteReport = (token, params) => {
    return axiosInstance.post(
        CREDIT_NOTE_REPORT_API_URL,
        params,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
};

//----------------------------------- MODULE & ROUTE CONFUIGURATION MODULE API SERVICES -----------------------------------

// GET MODULES LIST
export const getModules = (token) => {
    return axiosInstance.get(GET_MODULES_LIST_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
}

// GET MODULES LIST WITH ROUTES
export const getModuleSummary = (token) => {
    return axiosInstance.get(GET_MODULES_SUMMARY_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
}

// VIEW MODULE DETAILS BY ID
export const viewModuleDetails = (token, id) => {
    return axiosInstance.get(VIEW_MODULE_DETAILS_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
}

// GET PAGE TYPES LIST
export const getPageTypesList = (token) => {
    return axiosInstance.get(GET_PAGE_TYPES_API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
}

// CREATE NEW MODULE
export const createModule = (token, payload) => {
    return axiosInstance.post(CREATE_MODULE_API_URL, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
}

// UPDATE MODULE
export const updateModule = (token, id, payload) => {
    return axiosInstance.put(UPDATE_MODULE_API_URL(id), payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
}

// GET SUBMODULES LIST
export const getSubModulesList = (token, id) => {
    return axiosInstance.get(GET_SUBMODULES_LIST_API_URL(id), {
        headers: { Authorization: `Bearer ${token}` }
    });
}

//GET DELIVERY SCHEDULE TIME SLOTS
export const fetchDeliveryScheduleTimeSlots = (token) => {
    return axiosInstance.get(GET_DELIVERY_SCHEDULE_TIME_SLOTS_API_URL, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

//GET DEALERS BY SELECTED ROUTES AND DATE RANGE
export const fetchDealersByRoutes = (payload, token) => {
    return axiosInstance.post(GET_DEALERS_BY_ROUTES_API_URL, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
};

export const fetchDealersByRoutesHistory = (payload, token) => {
    return axiosInstance.post(GET_DEALERS_BY_ROUTES_HISTORY_API_URL, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
};

//CREATE DELIVERY SCHEDULE
export const createDeliverySchedule = (payload, token) => {
    return axiosInstance.post(CREATE_DELIVERY_SCHEDULE_API_URL, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
};




export const fetchDeliverySchedules = (token) => {
    return axiosInstance.get(GET_ALL_DELIVERY_SCHEDULES_API_URL, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export const fetchDeliveryScheduleById = (scheduleId, token) => {
    return axiosInstance.get(
        GET_DELIVERY_SCHEDULE_BY_ID_API_URL(scheduleId),
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );
};

export const updateDeliverySchedule = (scheduleId, payload, token) => {
    return axiosInstance.put(
        UPDATE_DELIVERY_SCHEDULE_API_URL(scheduleId),
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        },
    );
};

// VIEW DELIVERY SCHEDULE
export const viewDeliverySchedule = (profileId, token, date = null) => {
    const params = {};
    if (date) params.date = date;
    return axiosInstance.get(VIEW_DELIVERY_SCHEDULE_API_URL(profileId), {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params,
    });
};

// GET DISTRIBUTOR VEHICLES LIST
export const getDistributorVehicles = (profileId, token) => {
    return axiosInstance.get(GET_DISTRIBUTOR_VEHICLES_API_URL(profileId), {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

// Fetch SE list for selected distributor
export const fetchSalesExecutives = (
    profileId,
    distributorId,
    token,
) => {
    return axiosInstance.get(
        FETCH_SALES_EXECUTIVES_LIST(
            profileId,
            distributorId,
        ),
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );
};

// Fetch Productive / Non-Productive detail rows
export const fetchProductiveNonProductiveLogsDetails = (
    payload,
    token,
) => {
    return axiosInstance.post(
        FETCH_PRODUCTIVE_NON_PRODUCTIVE_LOGS_DETAILS,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        },
    );
};